// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/remote_filter_shells" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementRemoteFilterShells } from "./constants";
import type { EngagementRemoteFilterShellsResult } from "./types";

export const getEngagementRemoteFilterShells = reactQueryFetcherAdapter(
  engagementRemoteFilterShells,
  (
    signal: AbortSignal,
    appGroupId: string,
    eventName: string,
    eventNamespace: string,
    types: string[],
    limit: number,
    filterKey: string,
    query: string,
    prefilterShellValue?: string | string[],
    includeNonRetargetingCampaigns?: boolean
  ): Promise<EngagementRemoteFilterShellsResult[]> => {
    return fetch(
      "/engagement/remote_filter_shells",
      "GET",
      {
        app_group_id: appGroupId,
        "filter_config[eventName]": eventName,
        "filter_config[eventNamespace]": eventNamespace,
        "additional_params[types]": types,
        "additional_params[prefilter_shell_value]": prefilterShellValue,
        "additional_params[include_non_retargeting_campaigns]": includeNonRetargetingCampaigns,
        filter_key: filterKey,
        limit,
        query,
      },
      { signal }
    );
  }
);
